import styles from "@styles/SideBar.module.css"
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined"
import AssignmentIcon from "@mui/icons-material/Assignment"
import MailOutlineIcon from "@mui/icons-material/MailOutline"
import EmailIcon from "@mui/icons-material/Email"
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined"
import TaskIcon from "@mui/icons-material/Task"
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined"
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth"
import { useMessageContext } from "../context/MessageContext"
import {
  parseSearchParams,
  View,
  views,
} from "../helpers/utils/parseSearchParams"
import { useSearchParams } from "next/navigation"
import { updateUrlParams } from "../helpers/utils/navigation"

interface SideBarProps {
  collapsed: boolean
}

export default function SideBar({ collapsed }: SideBarProps) {
  // const [selectedSideBarItemType, setSelectedSideBarItemType] = useState<
  //   View | undefined
  // >()
  const searchParams = useSearchParams()
  const { view } = parseSearchParams(searchParams)

  // Click handlers
  const handleClick = (selectedView: View) => {
    updateUrlParams(searchParams, { view: selectedView })
  }

  // Handle messages
  const messageContext = useMessageContext()

  let unreadEmailThreads = 0
  if (messageContext) {
    const { messages } = messageContext
    const unreadThreadIds = new Set(
      messages.filter((m) => !m.isRead).map((m) => m.threadId)
    )
    unreadEmailThreads = unreadThreadIds.size
  }

  return (
    <div className={`${styles.container} ${collapsed ? styles.collapsed : ""}`}>
      <div>
        {views.map((viewToMap, index) => (
          <SideBarItem
            key={`sidebarItem_${viewToMap}${index}`}
            label={viewToMap}
            collapsed={collapsed}
            selected={viewToMap === view}
            onClick={() => handleClick(viewToMap)}
            openItems={viewToMap === "messages" ? unreadEmailThreads : 0}
            disabled={viewToMap === "calendar"}
          />
        ))}
      </div>
    </div>
  )
}

interface SideBarItemProps {
  label: View
  collapsed: boolean
  selected?: boolean
  onClick?: () => void
  openItems?: number
  disabled?: boolean
}

function SideBarItem({
  label,
  collapsed,
  selected,
  onClick,
  openItems,
  disabled,
}: SideBarItemProps) {
  const Icon = selected ? (
    label === "home" ? (
      <AssignmentIcon fontSize="small" />
    ) : label === "messages" ? (
      <EmailIcon fontSize="small" />
    ) : label === "tasks" ? (
      <TaskIcon fontSize="small" />
    ) : (
      <CalendarMonthIcon fontSize="small" />
    )
  ) : label === "home" ? (
    <AssignmentOutlinedIcon fontSize="small" />
  ) : label === "messages" ? (
    <MailOutlineIcon fontSize="small" />
  ) : label === "tasks" ? (
    <TaskOutlinedIcon fontSize="small" />
  ) : (
    <CalendarMonthOutlinedIcon fontSize="small" />
  )

  return (
    <div
      className={`${styles.itemContainer} ${
        collapsed ? styles.itemCollapsed : ""
      } ${selected ? styles.itemContainerSelected : ""} ${
        disabled ? styles.disabled : ""
      }`}
      onClick={() => {
        !disabled && onClick && onClick()
      }}
    >
      <div className={styles.itemIconContainer}>
        <div className={styles.itemIconContainerInner}>
          {Icon}
          {!!openItems && collapsed && (
            <div className={styles.openItemsIndicator}></div>
          )}
        </div>
      </div>
      <div
        className={`${styles.itemLabelContainer} ${
          openItems ? styles.boldLabel : ""
        }`}
      >
        {!collapsed && (
          <>
            <div>
              <span>{label}</span>
            </div>
            <div className={styles.openItemsContainer}>
              {!!openItems && <span>{openItems}</span>}
            </div>
          </>
        )}
      </div>
    </div>
  )
}
